module.exports = __webpack_public_path__ + "static/p2-e21ba395a2fffb84443d62b2bb325120.png";